export default __webpack_public_path__ + "static/media/brilliant_diamond_gemstone.c94b0a9b.png";